import { useState, useRef, useEffect } from 'react';
import { Tag } from 'modules/ai/copyAssist/constants';
import { StyledHighlightOverlay, StyledHighlightText } from 'modules/ai/copyAssist/styles';
import { noop } from 'utils/noop';
interface InputHighlightOverlayProps {
  value: string;
  /** ref for the element to target to create highlighting effect */
  targetRef?: React.RefObject<HTMLDivElement> | null;
  isAnimated?: boolean;
  onHighlightClick?: () => void;
}
export const InputHighlightOverlay = ({
  value,
  targetRef,
  isAnimated = true,
  onHighlightClick = noop,
}: InputHighlightOverlayProps) => {
  const highlightOverlayDivEl = useRef<HTMLSpanElement>(null);
  const [targetTag, setTargetTag] = useState<Tag | null>();

  useEffect(() => {
    if (
      targetRef &&
      targetRef?.current &&
      highlightOverlayDivEl &&
      highlightOverlayDivEl?.current
    ) {
      if (targetRef.current.querySelector(Tag.TextArea)) {
        setTargetTag(Tag.TextArea);
      } else {
        setTargetTag(Tag.Input);
      }
    }
  }, [value]);

  return (
    <StyledHighlightOverlay
      data-target-tag={targetTag}
      ref={highlightOverlayDivEl as any}
      key={value}
      data-test="copy-assist-input-highlight-overlay"
      data-animated={isAnimated}
      onClick={onHighlightClick}
    >
      <StyledHighlightText>{value}</StyledHighlightText>
    </StyledHighlightOverlay>
  );
};
